import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

type Props = {
    state?:Number;
}

const ComponentTopBreadCrumb = (props: Props) => {
    const {pathname} = useLocation()
    const location = useLocation()
    console.log(location)
    const history = useHistory()
  return (
    <div className='CompanyDetailsOuter'>
        <div className="CompanyDetails" style={{padding:'24px', fontSize:'16px'}}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="form-check form-check-custom form-check-solid form-check-sm">
              <input
              checked={props.state==1?true:false}
              onChange={e=>{if(e.target.checked) history.push({pathname:'/website/add-components-new'});}}
              className="form-check-input" type="radio" value="" id="flexRadioSm" name="componentType"/>
              <label style={{fontSize:'16px'}} className="form-check-label" htmlFor="flexRadioSm">
                Source from existing website
              </label>
            </div>
            <div className="form-check form-check-custom form-check-solid form-check-sm">
              <input
              checked={props.state==2?true:false}
              onChange={e=>{if(e.target.checked) history.push({pathname:'/website/add-components-non'});}}
              className="form-check-input" type="radio" value="" id="flexRadioSm2" name="componentType"/>
              <label style={{fontSize:'16px'}} className="form-check-label" htmlFor="flexRadioSm2">
                Source from non-existing website
              </label>
            </div>
            <div className="form-check form-check-custom form-check-solid form-check-sm">
              <input
              checked={props.state==3?true:false}
              onChange={e=>{if(e.target.checked) history.push({pathname:'/website/add-components-figma'});}}
              className="form-check-input" type="radio" value="" id="flexRadioSm3" name="componentType"/>
              <label style={{fontSize:'16px'}} className="form-check-label" htmlFor="flexRadioSm3">
                Figma Components
              </label>
            </div>
          </div>
        </div>
      </div>
  )
}

export default ComponentTopBreadCrumb